'use strict';

var UserStore = require('../stores/UserStore'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    ModalTypes = require('../constants/ModalTypes');

function handleUnauthAction(source) {
  if (!UserStore.isAuthenticated()) {
    ModalActionCreators.showModal(ModalTypes.ABOUT, {
      source: source
    });
    return true;
  }
}

module.exports = handleUnauthAction;



/** WEBPACK FOOTER **
 ** ./utils/handleUnauthAction.js
 **/